module.exports = __webpack_public_path__ + "static/hallway2-2ec027894db51cbc25fd422314e67b64.jpg";